<article class="batches-create">
  <h2 class="legal-title">
    {{ 'BATCH_MAILING.BATCHES_TAB.BATCH_CREATION' | translate }}
  </h2>

  @if (form) {
    <form
      @fadeIn
      class="batches-create-form"
      [formGroup]="form"
      id="batches-create-form-id"
      (ngSubmit)="submitForm()"
      #formEl
    >
      <section class="form-control">
        <label for="direction">
          {{
            'BATCH_MAILING.BATCHES_TAB.POSTAL_DELIVERY_DIRECTION' | translate
          }}
        </label>
        <select id="direction" formControlName="direction">
          <option selected hidden value="">
            {{
              'BATCH_MAILING.BATCHES_TAB.POSTAL_DELIVERY_DIRECTION_PLACEHOLDER'
                | translate
            }}
          </option>
          @for (item of DIRECTIONS; track item.value) {
            <option [value]="item.value">
              {{ item.label | translate }}
            </option>
          }
        </select>
        <app-control-errors control="direction" />
      </section>

      <section class="form-control">
        <label for="payment_type">
          {{ 'BATCH_MAILING.BATCHES_TAB.PAYMENT_TYPE' | translate }}
        </label>
        <select id="payment_type" formControlName="payment_type">
          <option selected hidden value="">
            {{
              'BATCH_MAILING.BATCHES_TAB.PAYMENT_TYPE_PLACEHOLDER' | translate
            }}
          </option>
          @for (item of PAYMENT_TYPE; track item.value) {
            <option [value]="item.value">
              {{ item.label | translate }}
            </option>
          }
        </select>
        <app-control-errors control="payment_type" />
      </section>

      <section class="form-control">
        <label for="postal_delivery_type">
          {{ 'BATCH_MAILING.BATCHES_TAB.POSTAL_DELIVERY_TYPE' | translate }}
        </label>
        <select
          id="postal_delivery_type"
          formControlName="postal_delivery_type"
        >
          <option selected hidden value="">
            {{
              'BATCH_MAILING.BATCHES_TAB.POSTAL_DELIVERY_TYPE_PLACEHOLDER'
                | translate
            }}
          </option>
          @for (item of POSTAL_TYPE; track item.value) {
            <option [value]="item.value">
              {{ item.label | translate }}
            </option>
          }
        </select>
        <app-control-errors control="postal_delivery_type" />
      </section>

      <!-- Выбор ЭЛС -->
      @if (form.get('card_number')) {
        <section class="form-control">
          <label for="card_number">{{ 'Выбор ЭЛС' | translate }}</label>
          <select id="card_number" formControlName="card_number">
            <option selected hidden value="">
              {{ 'BATCH_MAILING.BATCHES_TAB.SPECIFY' | translate }}
            </option>
            @for (item of cards; track item.id) {
              <option [value]="item.number">
                {{ item.name || item.number }}
              </option>
            }
          </select>
          <app-control-errors control="card_number" />
        </section>
      }

      <!-- Дополнительные критерии -->
      @if (showAdditionalCriteria()) {
        <section class="form-control">
          <label for="negotiated_rate">
            {{ 'BATCH_MAILING.BATCHES_TAB.ADDITIONAL_CRITERIA' | translate }}
          </label>
          <select id="negotiated_rate" formControlName="negotiated_rate">
            @for (item of NEGOTIATION_RATE; track item.value) {
              <option [value]="item.value">
                {{ item.label | translate }}
              </option>
            }
          </select>
          <app-control-errors control="negotiated_rate" />
        </section>
      }

      <!-- забор ПО -->
      @if (form.get('postal_items_in_ops')) {
        <section @fadeIn class="form-control">
          <label for="postal_items_in_ops">
            {{ 'BATCH_MAILING.BATCHES_TAB.RECEIVING_IN_OFFICE' | translate }}
          </label>
          <select
            id="postal_items_in_ops"
            formControlName="postal_items_in_ops"
          >
            <option selected hidden value="">
              {{
                'BATCH_MAILING.BATCHES_TAB.RECEIVING_IN_OFFICE_PLACEHOLDER'
                  | translate
              }}
            </option>
            @for (item of RECIVING; track item.value) {
              <option [value]="item.value">
                {{ item.label | translate }}
              </option>
            }
          </select>
          <app-control-errors control="postal_items_in_ops" />
        </section>
      }
    </form>
  }

  <!-- Объявленная ценность -->
  <section class="batches-create__checkbox-block">
    @if (showDeclaredValue) {
      <section @fadeIn class="form-control">
        <div class="checkbox">
          <input
            type="checkbox"
            id="is_declared_value"
            [formControl]="isDeclaredValueFormControl"
          />
          <label for="is_declared_value">
            <div class="checkbox__el"></div>
            <div class="checkbox__desc">
              <p class="h5">
                {{ 'BATCH_MAILING.BATCHES_TAB.IS_DECLARED_VALUE' | translate }}
              </p>
            </div>
          </label>
        </div>
      </section>
    }

    <!-- Получение части вложений -->
    @if (isPartialReceiptAvailable) {
      <section @fadeIn class="form-control">
        <div class="checkbox">
          <input
            type="checkbox"
            id="is_partial_receipt"
            [formControl]="isPartialReceiptFormControl"
          />
          <label for="is_partial_receipt">
            <div class="checkbox__el"></div>
            <div class="checkbox__desc">
              <p class="h5">
                {{
                  'BATCH_MAILING.BATCHES_TAB.GETTING_PART_OF_ATTACHMENT'
                    | translate
                }}
              </p>
            </div>
          </label>
        </div>
      </section>
    }
  </section>

  <footer class="batches-create-footer">
    <a
      class="button button--outlined button--shadow"
      [routerLink]="['..']"
      routerLinkActive="router-link-active"
    >
      {{ 'BACK' | translate }}
    </a>

    <button
      class="button button--filled button--shadow ml-3 d-flex"
      form="batches-create-form-id"
      [disabled]="isLoading"
      type="submit"
    >
      {{ 'BATCH_MAILING.BATCHES_TAB.CREATE' | translate }}

      @if (isLoading) {
        <div class="spinner spinner--alt text-center ml-2">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only">{{ 'LOADING' | translate }}</span>
          </div>
        </div>
      }
    </button>
  </footer>
</article>
